import { ChangeDetectorRef, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren, forwardRef,NgZone, HostListener } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/checkout-services/login.service';
import { ThrowStmt } from '@angular/compiler';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { OtpService } from 'src/app/services/checkout-services/-otp.service';
import { SharingService } from 'src/app/services/sharing.service';
import { MatBottomSheetRef, MatSnackBar } from '@angular/material';
import { environment } from 'src/environments/environment';
import { Utils } from 'src/app/Utils';
import { ApplicationStateService } from 'src/app/services/application-state.service';
import { AuthService } from 'src/app/services/auth.service';
import { ExternalRouterService } from 'src/app/services/external-router.service';
import { AppConfigService } from 'src/app/app-config.service';
import { NgOtpInputComponent } from 'ng-otp-input/lib/components/ng-otp-input/ng-otp-input.component';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-mobile',
  templateUrl: './mobile.component.html',
  styleUrls: ['./mobile.component.scss'],
  
})
export class MobileComponent implements OnInit {
  phoneNumber = null;
  sendOtpForm: FormGroup;
  otpSent: boolean = false;
  otpInput: string = "";
  loginForm: FormGroup;
  otpDto: { otpId: string, phoneNumber: string, otp: string };
  sending: boolean = true;
  reloadOtpSent = true;
  error: boolean = false;
  errorMsg: string = undefined;
  loginError: boolean = false;
  loginErrorMsg: string = undefined;
  timer = false;
  otpLength = 8;
  attemptsRemaining: number = 3;  // 🔥 ADD THIS
  mainObj: any = {};
  otpTimer: number = 120; // 2 minutes in seconds
displayTime: string = '02:00';
timerInterval: any;
timerExpired: boolean = false;
 

  constructor(
    private otpService: OtpService,
    private appConfigService: AppConfigService,
    private externalRouter: ExternalRouterService,
    private _bottomSheetRef: MatBottomSheetRef,
    private _loginService: LoginService,
    private authService: AuthService,
    private sharingService: SharingService,
    private _cookie: CookieService,
    private fb: FormBuilder,
    private loginService: LoginService,
    private cdr: ChangeDetectorRef,
    private applicationState: ApplicationStateService,
    private router: Router,
    private ngZone: NgZone
  ) {}

  ngOnInit() {
    this.otpService.isOtpAutoFilled.subscribe((otpValue: string) => {
      if (otpValue) {
        this.onOtpChange(otpValue);
        this.otpService.fillOtp(otpValue);
      }
    });

    if (this._cookie.get("UserID")) {
      this.router.navigate(['/order-and-address']);
    }

    this.otpSent = false;
    this.otpDto = { otpId: null, otp: null, phoneNumber: null };

    this.sendOtpForm = this.fb.group({
      phoneNumber: [, Validators.compose([
        Validators.required, Validators.minLength(10),
        Validators.maxLength(10), Validators.pattern(/^-?(0|[1-9]\d*)?$/)
      ])],
    });

    this.loginForm = this.fb.group({
      phoneNumber: [, Validators.required],
      otp: [this.otpInput, Validators.compose([Validators.required])],
      otpId: [, Validators.required]
    });

    this._bottomSheetRef.afterDismissed().subscribe(() => {});
  }

 onOtpChange(otp: string): void {
  if (this.loginForm.get('otp')) {
    this.loginForm.get('otp').setValue(otp);
  }
  //this.validClientSideLogin();
}

validClientSideLogin(): void {
  if (this.otpSent && this.loginForm.valid) {
    this.otpLogin();
  }
}


  sendOtp() {
  this.reloadOtpSent = false;
  this.sending = true;
  this.error = false;
  this.loginErrorMsg = undefined;
  this.loginError = false;
  this.timerExpired = false;

  if (this.sendOtpForm.valid) {
    this.otpService.sendOtp(this.sendOtpForm.value.phoneNumber).subscribe(res => {
      this.phoneNumber = res.body.phoneNumber;
      this.loginForm.controls['phoneNumber'].patchValue(this.phoneNumber);
      this.loginForm.controls['otpId'].patchValue(res.body.otpId);
      this.otpSent = true;
      this.reloadOtpSent = true;
      this.sending = false;
      this.error = false;
      this.otpLength = res.body.otpLength;

      this.loginForm.get('otp').setValidators([
        Validators.required,
        Validators.minLength(this.otpLength),
        Validators.maxLength(this.otpLength)
      ]);

      this.attemptsRemaining = 3;
      this.cdr.detectChanges();

      
      this.startOtpTimer();

    }, err => {
      this.error = true;
      this.sending = false;
      this.errorMsg = '';
      this.otpSent = false;
    });
  } else {
    this.sending = false;
    this.error = false;
  }
}



 startOtpTimer() {
  this.otpTimer = 120;
  this.timerExpired = false;
  this.updateDisplayTime();

  if (this.timerInterval) {
    clearInterval(this.timerInterval);
  }

  this.ngZone.runOutsideAngular(() => {
    this.timerInterval = setInterval(() => {
      this.otpTimer--;

      // Re-enter Angular zone to update UI
      this.ngZone.run(() => {
        if (this.otpTimer > 0) {
          this.updateDisplayTime();
        } else {
          this.timerExpired = true;
          clearInterval(this.timerInterval);
        }

        this.cdr.detectChanges(); // 🔁 Ensure view is updated
      });
    }, 1000);
  });
}


updateDisplayTime() {
  const minutes = Math.floor(this.otpTimer / 60);
  const seconds = this.otpTimer % 60;
  this.displayTime = `${this.pad(minutes)}:${this.pad(seconds)}`;
}

pad(num: number): string {
  return num < 10 ? '0' + num : num.toString();
}


resendOtp() {
    this.sendOtp();
}

  resetTime() {}

  otpLogin() {
    this.loginError = false;
    if (this.loginForm.valid) {
      this._loginService.otpLoginUser(this.loginForm.value).subscribe(response => {
        this._cookie.set("Authorization", response.headers.get('Authorization'));
        this._cookie.set("UserID", response.headers.get('UserID'));
        this.sharingService.updateApprovalMessage({
          Authorization: response.headers.get('Authorization'),
          UserID: response.headers.get('UserID')
        });

        this._bottomSheetRef.dismiss();
        const isMagicCheckoutEnabled = (this.appConfigService.config.MAGIC_CHECKOUT_ENABLED == undefined || this.appConfigService.config.MAGIC_CHECKOUT_ENABLED == null)
          ? environment.MAGIC_CHECKOUT_ENABLED : this.appConfigService.config.MAGIC_CHECKOUT_ENABLED;

        if (!isMagicCheckoutEnabled) {
          if (this.applicationState.getIsMobileResolution()) {
            this._cookie.set(Utils.phno, this.loginForm.value.phoneNumber);
            Utils.checkOutInMobile(this._cookie.get("controlProductId"), this.authService, this._cookie, this.externalRouter);
          } else {
            Utils.checkOutInDesktop(this._cookie.get("controlProductId"), this._cookie, this.externalRouter);
          }
        } else {
           
            this.router.navigate(['/my-account']);
          
        }

        // ✅ Reset attemptsRemaining to 0 after success with delay
        setTimeout(() => {
          this.attemptsRemaining = 0;
        }, 1000);  // 1 second delay

      }, err => {
        // 🔥 Handle wrong OTP attempt
        this.loginError = true;
        this.onError(err);

        if (this.attemptsRemaining > 0) {
          this.attemptsRemaining -= 1;
        }

        this.cdr.detectChanges();
      });
    }
  }

  onError(err) {
    this.loginErrorMsg = err.error.message;
    setTimeout(() => {
      this.loginError = false;
    }, 4000);
  }


  scrollIntoView(container: HTMLElement) {
  setTimeout(() => {
    container.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 300); // delay ensures keyboard is up
}

@HostListener('focusin', ['$event'])
onFocusIn(event: FocusEvent) {
  const target = event.target as HTMLElement;
  setTimeout(() => {
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, 300);
}

  ngOnDestroy() {
  if (this.timerInterval) {
    clearInterval(this.timerInterval);
  }
}
}

